/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// js/sections/countdown-timer.js
var CountdownTimer = class extends HTMLElement {
  connectedCallback() {
    
    const _this = this;
  
    let countdown_timerEl = this.querySelector(".countdown_timer");
    if(countdown_timerEl) {
      const dateStr = _this.getAttribute('data-time');
      const use_short_style =  (_this.getAttribute('data-use_short_style') === 'true');
      const hideDays = _this.getAttribute('data-hide-days');
      
      let countDownDate = new Date(dateStr).getTime();
      if(dateStr == '0') {
         countDownDate = new Date().setHours(23,59,59,999);
      }

      const timerDaysBlock = this.querySelector('.timer-days');
      const timerDaysElem = this.querySelector('.timer-days .timer-value');
      const timerDaysLabelElem = this.querySelector('.timer-days .timer-label');

      const timerHoursBlock = this.querySelector('.timer-hours');
      const timerHoursElem = this.querySelector('.timer-hours .timer-value');
       const timerHoursLabelElem = this.querySelector('.timer-hours .timer-label');

      const timerMinutesBlock = this.querySelector('.timer-minutes');
      const timerMinutesElem = this.querySelector('.timer-minutes .timer-value');
      const timerMinutesLabelElem = this.querySelector('.timer-minutes .timer-label');

      const timerSecondsBlock = this.querySelector('.timer-seconds');
      const timerSecondsElem = this.querySelector('.timer-seconds .timer-value');
      const timerSecondsLabelElem = this.querySelector('.timer-seconds .timer-label');
      

       let now = new Date().getTime();
        let distance = countDownDate - now;
        
        if(distance <= 0) {
          
            clearInterval(x);
            if(_this) {
              _this.style.display = 'none';

              if(_this.closest('.richtext_timer_block')) {
                _this.closest('.richtext_timer_block').style.display = 'none';
              }
                       if(_this.closest('.offer')) {
                _this.closest('.offer').style.display = 'none';
              }

              
            }
          
        }


        if(distance >= 0) {
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          if (hideDays == 'true') {
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + (24 * days);
          }
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);



          if(timerDaysLabelElem) {
            timerDaysLabelElem.innerHTML = window.languages.timer_days;
          }

          if(timerHoursLabelElem) {
            timerHoursLabelElem.innerHTML = window.languages.timer_hours;
          }

          if(timerMinutesLabelElem) {
            timerMinutesLabelElem.innerHTML = window.languages.timer_minutes;
          }


          if(timerSecondsLabelElem) {
            timerSecondsLabelElem.innerHTML = window.languages.timer_seconds;
          }
          
          
          
          if(days < 10) {
            days = "0"+days;
          }
          if(hours < 10) {
            hours = "0"+hours;
          }
          if(minutes < 10) {
            minutes = "0"+minutes;
          }
          if(seconds < 10) {
            seconds = "0"+seconds;
          }

        

          timerDaysElem.innerHTML = days;
          timerHoursElem.innerHTML = hours;
          timerMinutesElem.innerHTML = minutes;
          timerSecondsElem.innerHTML = seconds;

          if (days == 0) {
            timerDaysBlock.style.display = 'none';
          }
          if (days == 0 && hours == 0) {
            timerHoursBlock.style.display = 'none';
          }
          if (days == 0 && hours == 0 && minutes == 0) {
            timerMinutesBlock.style.display = 'none';
          }
        }
      
      let x = setInterval(function() {
        let now = new Date().getTime();
        let distance = countDownDate - now;
        
        if(distance <= 0) {
          
            clearInterval(x);
            if(_this) {
              _this.style.display = 'none';

              if(_this.closest('.richtext_timer_block')) {
                _this.closest('.richtext_timer_block').style.display = 'none';
              }
                       if(_this.closest('.offer')) {
                _this.closest('.offer').style.display = 'none';
              }

              
            }
          
        }


        if(distance >= 0) {
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          if (hideDays == 'true') {
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + (24 * days);
          }
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);



          if(timerDaysLabelElem) {
            timerDaysLabelElem.innerHTML = window.languages.timer_days;
          }

          if(timerHoursLabelElem) {
            timerHoursLabelElem.innerHTML = window.languages.timer_hours;
          }

          if(timerMinutesLabelElem) {
            timerMinutesLabelElem.innerHTML = window.languages.timer_minutes;
          }


          if(timerSecondsLabelElem) {
            timerSecondsLabelElem.innerHTML = window.languages.timer_seconds;
          }
          
          
          
          if(days < 10) {
            days = "0"+days;
          }
          if(hours < 10) {
            hours = "0"+hours;
          }
          if(minutes < 10) {
            minutes = "0"+minutes;
          }
          if(seconds < 10) {
            seconds = "0"+seconds;
          }

        

          timerDaysElem.innerHTML = days;
          timerHoursElem.innerHTML = hours;
          timerMinutesElem.innerHTML = minutes;
          timerSecondsElem.innerHTML = seconds;

          if (days == 0) {
            timerDaysBlock.style.display = 'none';
          }
          if (days == 0 && hours == 0) {
            timerHoursBlock.style.display = 'none';
          }
          if (days == 0 && hours == 0 && minutes == 0) {
            timerMinutesBlock.style.display = 'none';
          }
        }
      },1000);

    }

  }

};
if (!window.customElements.get("countdown-timer")) {
  window.customElements.define("countdown-timer", CountdownTimer);
}

